module.exports = __webpack_public_path__ + "static/arrow-bc19dee4dca58d33c7e4c135601b10db.webm";